import { CLASS_NAME_PREFIX } from "../constants";
export var createElementClass = function createElementClass(element) {
  return element ? CLASS_NAME_PREFIX + "__" + element : "";
};
export var createModifierClass = function createModifierClass(modifier, element) {
  return modifier ? "" + CLASS_NAME_PREFIX + (element ? "__" + element : "") + "--" + modifier : "";
};